(() => {
  'use strict';

  const componentSelector = '#razorpay-affordability-widget main-component';
  const styleId = 'bb-affordability-full-width-style';
  const shadowObservers = new WeakMap();

  const addFullWidthStyle = (component) => {
    const shadowRoot = component?.shadowRoot;

    if (!shadowRoot) {
      return false;
    }

    const ensureStyle = () => {
      if (shadowRoot.getElementById(styleId)) {
        return;
      }

      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        :host,
        main,
        .container,
        .wrapper,
        .content,
        .item {
          box-sizing: border-box !important;
          width: 100% !important;
          max-width: none !important;
        }
      `;
      shadowRoot.append(style);
    };

    ensureStyle();

    if (!shadowObservers.has(shadowRoot)) {
      const shadowObserver = new MutationObserver(ensureStyle);
      shadowObserver.observe(shadowRoot, { childList: true });
      shadowObservers.set(shadowRoot, shadowObserver);
    }

    return true;
  };

  const start = () => {
    const host = document.querySelector('#razorpay-affordability-widget');

    if (!host) {
      return;
    }

    let pageObserver;

    const tryApply = () => {
      const component = document.querySelector(componentSelector);

      if (addFullWidthStyle(component)) {
        pageObserver?.disconnect();
        return true;
      }

      return false;
    };

    if (tryApply()) {
      return;
    }

    pageObserver = new MutationObserver(() => {
      tryApply();
    });
    pageObserver.observe(host, { childList: true, subtree: true });

    window.customElements?.whenDefined('main-component').then(tryApply).catch(() => {});

    window.setTimeout(() => pageObserver?.disconnect(), 10000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
